// extracted by mini-css-extract-plugin
module.exports = {"groupLogo":"styles_groupLogo__aZa4R","mask":"styles_mask__GY1eq","maskIcon":"styles_maskIcon__3Mejk"};